import { BaseDto } from "./base.dto";

export class CustomerLoyaltyTransactionDto extends BaseDto {
    customerId?: number;
    brandId?: number;
    orderId?: number;
    loyaltyPoints?: number;
    isBurned?: boolean;
}